import { environment } from 'environments/environment';

/**
 * Resuelve el valor a mostrar de un mapa embedded-i18n (`<campo>I18n`) por locale.
 * Cadena de fallback: idioma activo -> idioma base del panel -> primer locale
 * traducido de la fila (translatedLocales[0]) -> cadena vacía.
 *
 * @param map               el mapa per-locale de la fila (p. ej. row.labelI18n / row.<rel>?.labelI18n)
 * @param activeLang        el idioma activo, resuelto por el caller como
 *                          `translator?.getActiveLang()`. Puede ser `undefined`
 *                          cuando no hay translator disponible: en ese caso se
 *                          salta directo al fallback de `environment.lang.base`
 *                          (el helper ya lo aplica internamente).
 * @param translatedLocales los locales presentes en la fila destino (row.translatedLocales
 *                          o row.<rel>?.translatedLocales)
 */
export function resolveI18nValue(
  map: Record<string, string> | null | undefined,
  activeLang: string | undefined,
  translatedLocales?: string[] | null,
): string {
  const m = map ?? {};
  const fallbackLocale = translatedLocales?.[0];
  return (
    (activeLang ? m[activeLang] : undefined) ??
    m[environment.lang.base] ??
    (fallbackLocale ? m[fallbackLocale] : undefined) ??
    ''
  );
}
